
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcDivider as ObcDividerElement} from '@oicl/openbridge-webcomponents/dist/components/divider/divider.js';
 
 
 

 
 export const ObcDivider = createComponent({
   react: React,
   tagName: 'obc-divider',
   elementClass: ObcDividerElement,
   events: {
     
   }
  });
 
 